// «Propuesta para Santi» (entrega 3, construccion.md §«Entrega 3»): lo que el agente de un hilo propone decirle a Santi
// (`pelota_proponer`, o «Que lo prepare tu agente») sale en SU chat, al final, y nunca entra solo en la caja. Dos cosas:
// «Usar en la caja» (pasa el texto a la caja de Santi, editable, con «Deshacer»; el servidor la da por usada) y «Cambiar»
// (Pau se lo dice al agente en ese mismo chat: lleva el cursor a su caja). Lo que sale a Santi sigue saliendo de la caja,
// con «Enviar». Un socio la ve sin botones (no tiene caja de Santi: lo que sale hacia Santi lo envía Pau).
// Solo la vigente (sin `usadaEn`). Se pinta al final del chat a partir del hilo (la API de pelotas la sirve siempre); el
// mensaje de sistema `propuesta_santi` que la oficina deja en el chat del agente no se pinta aparte (lineaDeTiempo no
// pinta mensajes de sistema), así que no sale dos veces. Si al usarla ya hubo otra después (409), lo dice aquí.
import { Send } from 'lucide-react';
import { useState } from 'react';
import { t } from '../../../i18n';
import { Boton } from '../ui';
import { useHablaComoPau, usePelotasStore } from './store';
import { propuestaVigente } from './tipos';

export function PropuestaEnElChat({ hilo, alCambiar }: { hilo: number | 'general'; alCambiar: () => void }) {
  const propuesta = usePelotasStore((s) => propuestaVigente(hilo === 'general' ? s.general : s.hilos[hilo]));
  const usar = usePelotasStore((s) => s.usarPropuesta);
  const comoPau = useHablaComoPau();
  const [usando, setUsando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!propuesta) return null;
  return (
    <div className="mt-3 pl-10 pr-3" data-testid="propuesta-santi" data-tipo={propuesta.tipo}>
      <div className="rounded-o-l border border-oficina-acento/30 bg-oficina-tuyo-globo px-3.5 py-3">
        <p className="flex items-center gap-1.5 text-o-sub font-semibold text-oficina-meta-pau">
          <Send className="h-3.5 w-3.5 shrink-0" aria-hidden />
          {t(propuesta.tipo === 'cerrar' ? 'oficinaV2.pelotas.propuesta.tituloCerrar' : 'oficinaV2.pelotas.propuesta.titulo')}
        </p>
        <p className="mt-1.5 whitespace-pre-wrap break-words text-o-cuerpo text-oficina-texto" data-testid="propuesta-texto">
          {propuesta.texto}
        </p>
        {propuesta.porque ? <p className="mt-1.5 text-o-sub text-oficina-texto2">{propuesta.porque}</p> : null}
        {comoPau ? (
          <div className="-ml-1 mt-2.5 flex flex-wrap items-center gap-1.5">
            <Boton
              variante="secundario"
              tamano="sm"
              cargando={usando}
              onClick={() => {
                setUsando(true);
                setError(null);
                void usar(hilo)
                  .then(setError)
                  .finally(() => setUsando(false));
              }}
              data-testid="propuesta-usar"
            >
              {t('oficinaV2.pelotas.propuesta.usar')}
            </Boton>
            <Boton variante="fantasma" tamano="sm" onClick={alCambiar} className="text-oficina-texto2 hover:text-oficina-texto" data-testid="propuesta-cambiar">
              {t('oficinaV2.pelotas.propuesta.cambiar')}
            </Boton>
          </div>
        ) : null}
        {error ? (
          <p role="alert" className="mt-2 text-o-sub text-oficina-bloqueado" data-testid="propuesta-error">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
